import React from 'react';
import { useDateDisplay } from "../../utils";
import { useReactAppState } from "../../../shared/containers/utils";

const MatchHeader = ({ matchDate, dateRangeType, showTimeZone = false }) => {
  const { t } = useReactAppState();
  const dateDisplay = useDateDisplay(matchDate, dateRangeType);

  return (
    <div className={"mls-c-schedule__match-header"}>
      <span className={"mls-c-schedule__date-display"}>{dateDisplay}</span>
      {showTimeZone ? <span className={"mls-c-schedule__time-zone"}>{t("match_schedule_timezone")}</span> : null}
    </div>
  );
};

export default MatchHeader;
